module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.prefixCls + '-operation'
  }, [_c('i-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.rightActive
    },
    nativeOn: {
      "click": function($event) {
        _vm.moveToLeft($event)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-left"
    }
  }), _vm._v(" " + _vm._s(_vm.operations[0]) + "\n    ")], 1), _vm._v(" "), _c('i-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.leftActive
    },
    nativeOn: {
      "click": function($event) {
        _vm.moveToRight($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.operations[1]) + " "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-right"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a7ac1f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/transfer/operation.vue
// module id = 611
// module chunks = 1